<section class="cmn-innerpage-wrapper expense-details">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <button class="cmn-add-btn" (click)="openCreateDialog()" *ngIf="canCreateExpenses$ | async">
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New Expense
    </button>

    <!-- Filter -->
  </div>
  <div class="sub-head">
    <ul>
      <li class="main">All Expenses</li>
      <li
        *ngIf="isEditableStatus() && (canEditExpenses$ | async)"
        class="edit"
        (click)="navigateToEditPage()"
      >
        <img src="assets/images/icons/icon-edit-accounts.svg" alt="Edit" />
        Edit
      </li>

      <li *ngIf="isDeletableStatus() && (canDeleteExpenses$ | async)" class="delete" (click)="onRemoveExpense()">
        <img src="assets/images/icons/icon-delete-li.svg" alt="Delete" />
        Delete
      </li>

      <!-- <li class="edit" (click)="onViewDocument()">
        <img src="assets/images/icons/icon-pdf.svg" alt="PDF" />
        PDF
      </li> -->
    </ul>

    <div class="mat-menu-wrapper">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
        *ngIf="expenseData?.expenseStatus === 'Approved'"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="markAsSent(expenseData?.id)">
          <span>Mark as Sent</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="manual-journal-details-tab-wrapper" *ngIf="canListExpenses$ | async">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          *ngFor="let expense of allExpenses; let i = index"
          class="tab-custom-button"
          [class.active]="selectedTabIndex === i"
          (click)="selectTab(i)"
        >
          <div class="inn-box">
            <h2>
              {{
                expense?.paidByData?.firstName +
                  " " +
                  expense?.paidByData?.lastName
              }}
            </h2>
            <h3>AED {{ (expense?.amount || 0) + (expense?.tax || 0) | number : "1.2-2" }}</h3>
          </div>
          <div class="inn-box">
            <h6>{{ expense?.expenseDate | date : "dd MMM yyyy" }}</h6>
            <h5>{{ expense?.expenseStatus }}</h5>
          </div>
          <div class="inn-box">
            <h4 class="grey">{{ expense?.expenseType }}</h4>
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div *ngIf="expenseData">
        <div class="chart-tab-content">
          <div class="tab-main-container">
            <div class="tab-inner">
              <div class="note-header">
                <div class="journal-details">
                  <div class="right-set">
                    <h2>EXPENSE RECEIPT</h2>
                    <h3>{{ expenseData?.referenceNo || 'No Reference' }}</h3>
                    
                    <div class="details-box">
                      <h4>Expense Date</h4>
                      <h5>:</h5>
                      <h6 class="expense-detail-content">
                        {{ expenseData?.expenseDate | date : "dd MMM yyyy" }}
                      </h6>
                    </div>
                    <div class="details-box">
                      <h4>Expense Type</h4>
                      <h5>:</h5>
                      <h6 class="expense-detail-content">
                        {{ expenseData?.expenseType }}
                      </h6>
                    </div>
                  </div>
                </div>

                <div class="left-set">
                  <div *ngIf="expenseData?.paidByData">
                    <h4>Paid By:</h4>
                    <h3>
                      <span>{{
                        expenseData?.paidByData?.firstName +
                          " " +
                          expenseData?.paidByData?.lastName
                      }}</span>
                    </h3>
                  </div>
                  <div *ngIf="expenseData?.approvedByData && expenseData?.approvedBy">
                    <h4>Approved By:</h4>
                    <h3>
                      <span>{{
                        expenseData?.approvedByData?.firstName +
                          " " +
                          expenseData?.approvedByData?.lastName
                      }}</span>
                    </h3>
                    <h3>Employee ID: {{ expenseData?.approvedBy }}</h3>
                    <h3>Department: {{ expenseData?.approvedByData?.department || 'N/A' }}</h3>
                    <h3>Designation: {{ expenseData?.approvedByData?.designation || 'N/A' }}</h3>
                  </div>
                </div>
              </div>
              <div class="crdit-note-page-table">
                <div class="expense-details-section">
                  
                  <div class="detail-item">
                    <h4>Payment Method</h4>
                    <h6>{{ expenseData?.paymentMethod || 'N/A' }}</h6>
                  </div>
                  
                  <div class="detail-item" *ngIf="expenseData?.paymentMethod === 'Bank' && expenseData?.bankAccountData">
                    <h4>Bank Details</h4>
                    <h6>Bank: {{ expenseData?.bankAccountData?.bankName }}</h6>
                    <h6>Account: {{ expenseData?.bankAccountData?.accountNumber }}</h6>
                  </div>
                  
                  <div class="detail-item" *ngIf="expenseData?.paymentMethod === 'Credit Card' && expenseData?.creditCardData">
                    <h4>Card Details</h4>
                    <h6>Card: {{ expenseData?.creditCardData?.cardName }}</h6>
                    <h6>Number: {{ expenseData?.creditCardData?.cardNumber }}</h6>
                  </div>
                  
                  <div class="detail-item" *ngIf="expenseData?.isCheque === true">
                    <h4>Cheque Details</h4>
                    <h6>Cheque No: {{ expenseData?.chequeNo }}</h6>
                    <h6>Date: {{ expenseData?.chequeDate | date : "dd MMM yyyy" }}</h6>
                  </div>
                  
                  <div class="detail-item">
                    <h4>Account</h4>
                    <h6>{{ expenseData?.accountData?.accountName }} ({{ expenseData?.accountData?.accountType }})</h6>
                  </div>
                  
                  <div class="detail-item" *ngIf="expenseData?.description">
                    <h4>Description</h4>
                    <h6>{{ expenseData?.description }}</h6>
                  </div>
                </div>
              </div>
              <div class="page-footer-content">
                <div class="left-set"></div>
                <div class="right-set">
                  <div class="details-box">
                    <h4>Total Amount</h4>
                    <h5>:</h5>
                    <h6>
                      AED {{ expenseData?.amount | number : "1.2-2" }}
                    </h6>
                  </div>
                  <div class="details-box" *ngIf="expenseData?.tax">
                    <h4>Tax Amount</h4>
                    <h5>:</h5>
                    <h6>AED {{ expenseData?.tax | number : "1.2-2" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>Net Amount</h4>
                    <h5>:</h5>
                    <h6>AED {{ (expenseData?.amount || 0) + (expenseData?.tax || 0) | number : "1.2-2" }}</h6>
                  </div>
                </div>
              </div>

              <!-- <span
                class="published-note"
                *ngIf="expenseData?.status === 'Draft'"
                ><img src="assets/images/img-draft.svg" alt="canceled"
              /></span>
              <span
                class="published-note"
                *ngIf="expenseData?.status === 'Paid'"
                ><img src="assets/images/img-closed.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="expenseData?.status === 'Open'"
                ><img src="assets/images/img-open.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="expenseData?.status === 'DECLINED'"
                ><img src="assets/images/img-cancelled.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="expenseData?.status === 'Sent'"
                ><img src="assets/images/img-issued.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="expenseData?.status === 'Cancelled'"
                ><img src="assets/images/img-cancelled.svg" alt="Cancel"
              /></span> -->

              <p
                *ngIf="
                  (expenseData?.expenseStatus === 'Approved' ||
                  expenseData?.expenseStatus === 'Rejected') &&
                  expenseData?.approvedByData &&
                  expenseData?.approvedBy
                "
                class="approvedBy"
              >
                {{ expenseData?.expenseStatus === 'Approved' ? "Approved By" : "Rejected By" }} :
                {{ expenseData?.approvedByData?.firstName + " " + expenseData?.approvedByData?.lastName }}
              </p>
              <p class="signature">Authorized Signature <span></span></p>
            </div>
          </div>

          <div
            *ngIf="expenseData?.expenseStatus === 'Pending'"
            class="expense-details-footer-wrapper"
          >
            <div class="submit-btn-wrapper" *ngIf="canApproveRejectExpenses$ | async">
              <button
                class="cmn-next-btn"
                type="button"
                (click)="handleApproval(true, expenseData.id)"
              >
                Approve
              </button>
              <button
                class="cmn-next-btn"
                type="button"
                (click)="handleApproval(false, expenseData.id)"
              >
                Reject
              </button>
            </div>
          </div>
          <div
            *ngIf="
              (expenseData.expenseStatus === 'Approved' ||
              expenseData.expenseStatus === 'Sent') &&
              expenseData.journalData &&
              expenseData.journalData.journalEntries
            "
            class="credit-note-footer-table-wrapper"
          >
            <table>
              <tr class="title">
                <td>Journal</td>
              </tr>

              <tr>
                <td>
                  Date:
                  {{
                    expenseData?.journalData?.createdAt | date : "dd MMM yyyy"
                  }}
                </td>
              </tr>
              <tr>
                <td>Journal No: {{ expenseData?.journalData?.journalNo }}</td>
              </tr>
              <tr>
                <td>Account</td>
                <td>Debit</td>
                <td>Credit</td>
              </tr>
              <tr
                class="bold"
                *ngFor="
                  let entry of expenseData?.journalData?.journalEntries || []
                "
              >
                <td>
                  {{ entry?.accountData?.accountName }}
                </td>
                <td>AED {{ entry.debit | number : "1.2-2" }}</td>
                <td>AED {{ entry.credit | number : "1.2-2" }}</td>
              </tr>
              <tr class="bold">
                <td></td>
                <td>AED {{ getDebitTotal() | number : "1.2-2" }}</td>
                <td>AED {{ getCreditTotal() | number : "1.2-2" }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> 